import { useMutation, useQueryClient } from '@tanstack/react-query';

import { apiClient } from '@/lib/api/client';
import { useTenantStore } from '@/stores/tenantStore';

import type { SaveWorkflowCanvasInput } from '../schemas/workflowSchemas';
import { workflowDetailDtoSchema } from '../schemas/workflowSchemas';
import { workflowKeys } from './workflowKeys';

interface SaveWorkflowCanvasParams extends SaveWorkflowCanvasInput {
  workflowId: string;
}

export function useSaveWorkflow() {
  const qc = useQueryClient();
  const tenantId = useTenantStore((s) => s.tenantId);

  return useMutation({
    mutationFn: async ({ workflowId, canvasJson, schemaVersion }: SaveWorkflowCanvasParams) => {
      const raw = await apiClient
        .put(`api/v1/t/${tenantId}/workflows/${workflowId}/canvas`, {
          json: { canvasJson, schemaVersion },
        })
        .json();
      return workflowDetailDtoSchema.parse(raw);
    },
    onSuccess: (data) => {
      qc.setQueryData(workflowKeys.detail(data.id), data);
    },
  });
}
